import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Казбеков Серік',
  role: 'Т.в.о. Голови скельного комітету',
  email: 's.kazbekov@umcf.org.ua'
}, {
  name: 'Боровик Олена',
  role: 'Секретар комітету',
  email: 'fais.org.ua@gmail.com'
}, {
  name: 'Заколодна Ольга',
  role: 'Голова комісії спортивного скелелазіння',
  email: 'olya-zak@ukr.net'
}];
export function ClimbingCommittee() {
  return <FederationMembersPage title="Комітет скелелазіння" subtitle="Керівний орган скельного напрямку ФАіСУ" members={members} data-id="element-522" />;
}